/** Suno voices (owner session cookie): Suno learns your real singing voice → pick it in the song model menu. */
import axios from "axios";
import { API, uploadReferenceFile } from "@/lib/creatorApi";
import { SUNO_MODELS } from "@/components/suno/constants";

const http = axios.create({ baseURL: `${API}/suno/custom-models`, withCredentials: true });
const data = (p) => p.then((r) => r.data);

export const listSunoVoices = () => data(http.get(""));
export const getSunoVoice = (id) => data(http.get(`/${id}`));
export const createSunoVoice = (body) => data(http.post("", body));
export const askNewPhrase = (id) => data(http.post(`/${id}/phrase/again`));
export const remakeSunoVoice = (id) => data(http.post(`/${id}/remake`));
export const checkVoicesNow = () => data(http.post("/health-check"));
export const verifySunoVoice = (id, verifyUrl) => data(http.post(`/${id}/verify`, { verify_url: verifyUrl }));
export const patchSunoVoice = (id, body) => data(http.patch(`/${id}`, body));
export const deleteSunoVoice = (id) => data(http.delete(`/${id}`));
export const uploadVoiceAudio = (file) => uploadReferenceFile(file);
export const setDefaultVoice = (id) => data(http.post(`/${id}/default`));
export const clearDefaultVoice = (id) => data(http.delete(`/${id}/default`));
export const makeVoiceClip = (id) => data(http.post(`/${id}/sample`));
export const clipSrc = (clip) => `${process.env.REACT_APP_BACKEND_URL}${clip.url}`;
export const defaultVoice = (voices) => (voices || []).find((v) => v.is_default && ["ready", "broken"].includes(v.status)) || null;

export const MAX_AUDIO_BYTES = 30 * 1024 * 1024;
export const BASE_MODELS = SUNO_MODELS.filter((m) => !m.legacy);
export const CLIP_BUSY = { listening: "Listening to the words you sang…", composing: "ELPM is singing your words with a full gospel band…", saving: "Saving the clip…" };
export const clipBusy = (v) => Boolean(CLIP_BUSY[v?.sample?.status]);
export const isWaiting = (v) => ["phrase", "creating"].includes(v?.status) || clipBusy(v);

export const VOICE_STATUS = {
  phrase: { label: "Getting your phrase", tone: "wait" },
  sing: { label: "Sing the phrase", tone: "todo" },
  creating: { label: "Building your voice", tone: "wait" },
  ready: { label: "Ready", tone: "good" },
  error: { label: "Needs attention", tone: "bad" },
  broken: { label: "Needs re-making", tone: "bad" },
};

export const SKILLS = [
  ["beginner", "Beginner"], ["intermediate", "Intermediate"], ["advanced", "Advanced"], ["professional", "Professional"],
];

export const LANGUAGES = [
  ["en", "English"], ["es", "Spanish"], ["fr", "French"], ["pt", "Portuguese"], ["de", "German"],
  ["zh", "Chinese"], ["ja", "Japanese"], ["ko", "Korean"], ["hi", "Hindi"], ["ru", "Russian"],
];

export const clock = (s) => `${Math.floor((s || 0) / 60)}:${String(Math.floor((s || 0) % 60)).padStart(2, "0")}`;
